function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Check } from '@finect/tabular-icons/check';
import { withTheme } from 'styled-components';
import { iconSizes } from '../commons/iconSizes';
import { PRODUCT_TYPES_WITH_ICON } from '../Products/productTypesWithIcon';
import { getImageUrl } from '../Image/utils';
import { DefaultAvatar, DefaultIconCompany, DefaultIconGroup, DefaultIconTag, DefaultIconStorefront, AdIcon, Verified, Online } from './partials';
import { IconImage } from './IconImage';
var EFPA_ICON = 'https://static.finect.com/img/efpa_logo.jpg';
var Icon = function (_React$Component) {
  _inherits(Icon, _React$Component);
  var _super = _createSuper(Icon);
  function Icon() {
    var _this;
    _classCallCheck(this, Icon);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "icon", void 0);
    _defineProperty(_assertThisInitialized(_this), "adIcon", void 0);
    _defineProperty(_assertThisInitialized(_this), "state", {
      isDefault: false
    });
    _defineProperty(_assertThisInitialized(_this), "loadDefault", function () {
      _this.setState({
        isDefault: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      event.preventDefault();
      if (!_this.props.aditionalIcon) return;
      var url = _this.props.aditionalIcon.url;
      location.href = url;
    });
    return _this;
  }
  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        theme = _this$props.theme,
        alt = _this$props.alt,
        image = _this$props.image,
        url = _this$props.url,
        _this$props$size = _this$props.size,
        size = _this$props$size === void 0 ? 3 : _this$props$size,
        type = _this$props.type,
        fill = _this$props.fill,
        withBorder = _this$props.withBorder,
        _this$props$withRound = _this$props.withRoundedCorners,
        withRoundedCorners = _this$props$withRound === void 0 ? false : _this$props$withRound,
        verified = _this$props.verified,
        inverted = _this$props.inverted,
        margin = _this$props.margin,
        aditionalIcon = _this$props.aditionalIcon,
        lightDefaultIcon = _this$props.lightDefaultIcon,
        color = _this$props.color,
        isOnline = _this$props.isOnline;
      var isDefault = this.state.isDefault;
      var small = size < 2;
      var imageURL = image ? getImageUrl(image, {
        width: iconSizes[size],
        height: iconSizes[size]
      }) : '';
      var iconProps = {
        theme: theme,
        nonScaling: !small,
        fill: fill,
        lightDefaultIcon: lightDefaultIcon,
        color: color,
        size: iconSizes[size].toString()
      };
      var defaultIcon;
      switch (type) {
        case 'company':
          defaultIcon = React.createElement(DefaultIconCompany, iconProps);
          break;
        case 'group':
          defaultIcon = React.createElement(DefaultIconGroup, iconProps);
          break;
        case 'tag':
          defaultIcon = React.createElement(DefaultIconTag, iconProps);
          break;
        case 'storefront':
          defaultIcon = React.createElement(DefaultIconStorefront, iconProps);
          break;
        default:
          {
            var ProductIcon = PRODUCT_TYPES_WITH_ICON[type] || null;
            defaultIcon = ProductIcon ? React.createElement(ProductIcon, iconProps) : React.createElement(DefaultAvatar, iconProps);
          }
      }
      var verifiedSize = size === 0 ? {
        badgeSize: 14,
        iconSize: 8,
        stroke: 4
      } : size && size >= 1 && size <= 3 ? {
        badgeSize: 18,
        iconSize: 10,
        stroke: 4
      } : {
        badgeSize: 24,
        iconSize: 14,
        stroke: 3
      };
      var imageProps = url ? {
        href: url,
        as: 'a'
      } : {};
      return React.createElement(IconImage, _extends({
        withRoundedCorners: withRoundedCorners,
        small: small,
        sizeParam: iconSizes[size],
        withBorder: withBorder,
        lightDefaultIcon: lightDefaultIcon,
        margin: margin
      }, imageProps), imageURL && !isDefault ? React.createElement("img", {
        ref: function ref(img) {
          return _this2.icon = img;
        },
        width: String(iconSizes[size]),
        height: String(iconSizes[size]),
        alt: alt,
        src: imageURL,
        onError: this.loadDefault
      }) : defaultIcon, verified && React.createElement(Verified, {
        size: verifiedSize.badgeSize,
        iconSize: verifiedSize.iconSize,
        inverted: inverted
      }, React.createElement(Check, {
        size: verifiedSize.iconSize.toString(),
        strokeWidth: verifiedSize.stroke.toString()
      })), isOnline ? React.createElement(Online, {
        position: "top",
        size: verifiedSize.badgeSize,
        iconSize: verifiedSize.badgeSize
      }, React.createElement("svg", {
        height: "18",
        width: "18",
        viewBox: "0 0 18 18"
      }, React.createElement("circle", {
        cx: "9",
        cy: "9",
        r: "7",
        stroke: "white",
        strokeWidth: "3"
      }))) : null, aditionalIcon ? React.createElement(AdIcon, {
        onClick: this.handleClick,
        small: small,
        size: verifiedSize.badgeSize,
        title: aditionalIcon.name
      }, React.createElement("img", {
        alt: aditionalIcon.name,
        ref: function ref(img) {
          return _this2.adIcon = img;
        },
        src: aditionalIcon.icon,
        onError: function onError() {
          if (aditionalIcon.name === 'EFPA') {
            return _this2.adIcon.src = EFPA_ICON;
          }
          _this2.adIcon.style.display = 'none';
        }
      })) : null);
    }
  }]);
  return Icon;
}(React.Component);
_defineProperty(Icon, "defaultProps", {
  size: 3,
  type: 'user'
});
export default withTheme(Icon);